module.exports = __webpack_public_path__ + "img/series_04.4b36e09b.png";